import { axiosClient } from '@/shared/api/axiosClient';
import type { ApiSuccess } from '@/shared/api/apiResponse.types';
import type { SpotifyPlaylist, SpotifyStatus, SpotifyTrack } from '../model/spotify.types';

export const spotifyApi = {
  getStatus: () =>
    axiosClient
      .get<ApiSuccess<SpotifyStatus>>('/dj/spotify/status')
      .then((r) => r.data.data),

  getAuthUrl: () =>
    axiosClient
      .get<ApiSuccess<{ url: string }>>('/dj/spotify/connect')
      .then((r) => r.data.data.url),

  getPlaylists: () =>
    axiosClient
      .get<ApiSuccess<SpotifyPlaylist[]>>('/dj/spotify/playlists')
      .then((r) => r.data.data),

  disconnect: () =>
    axiosClient.delete('/dj/spotify/disconnect'),

  searchTracks: (eventCode: string, q: string) =>
    axiosClient
      .get<ApiSuccess<SpotifyTrack[]>>(`/events/${eventCode}/spotify/search`, { params: { q } })
      .then((r) => r.data.data),
};
